export const INCOME_ACCIDENT = {
  nickname: 'PRODUCTS.INCOME_ACCIDENT.shortname',
  isHidden: true,
  icon:'income-accident'
};
